<template>
  <div id="app">
    <router-view />

    <!-- Notificaciones Globales -->
    <ToastNotifications />
    <GlobalConfirmDialog />

    <!-- Toast de actualización -->
    <div v-if="isNewVersionAvailable" class="fixed bottom-4 right-4 z-50 animate-bounce">
      <div
        class="bg-slate-900 text-white px-6 py-4 rounded-lg shadow-xl border border-slate-700 flex items-center gap-4 max-w-md">
        <div class="flex-1">
          <h4 class="font-bold text-sm text-emerald-400 mb-1">¡Actualización Disponible!</h4>
          <p class="text-xs text-slate-300">Hay una nueva versión del sistema. Actualiza para ver los cambios.</p>
        </div>
        <button @click="refreshApp"
          class="bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-bold py-2 px-4 rounded transition-colors">
          Actualizar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useVersionCheck } from '@/composables/useVersionCheck'
import ToastNotifications from '@/components/ToastNotifications.vue'
import GlobalConfirmDialog from '@/components/GlobalConfirmDialog.vue'

const { isNewVersionAvailable, refreshApp } = useVersionCheck()
</script>

<style>
#app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  background-color: #f8f9fa;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: inherit;
}
</style>